import { createFileRoute } from "@tanstack/react-router";
import AboutEs from "@/pages/es/AboutEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/about`;

export const Route = createFileRoute("/es/about")({
  head: () => ({
    meta: [
      { title: "Sobre nosotros | Neuro Wellness TMS Centers of America" },
      {
        name: "description",
        content:
          "Conozca a Neuro Wellness TMS Centers of America, especialistas en neuromodulación psiquiátrica en Coral Springs, FL. Proveedor verificado de SAINT® TMS en.",
      },
      {
        property: "og:title",
        content: "Sobre Neuro Wellness TMS Centers of America",
      },
      {
        property: "og:description",
        content:
          "Especialistas en neuromodulación psiquiátrica en Coral Springs, FL. Proveedor verificado de SAINT® TMS.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "Sobre Neuro Wellness TMS Centers of America",
      },
      {
        name: "twitter:description",
        content:
          "Especialistas en neuromodulación psiquiátrica en Coral Springs, FL. Proveedor verificado de SAINT® TMS.",
      },
    ],
    links: [{ rel: "canonical", href: ES_URL }, ...buildHreflang("/about")],
  }),
  component: () => <AboutEs />,
});
